var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('iframe',{attrs:{"allow":"camera; microphone; fullscreen; speaker; display-capture","width":"100%","height":"600","src":this.meta.attendee_url+'?_nickname='+_vm.consumer.name,"frameborder":"0","allowfullscreen":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }